import React from "react";
import styles from "./NotificationBadge.module.scss";

const MAX_BADGE_COUNT = 9;

const getBadgeLabel = (count) => (count > MAX_BADGE_COUNT ? `${MAX_BADGE_COUNT}+` : count);

const NotificationBadge = ({ children, count = 0 }) => (
  <span className={styles.badgeContainer}>
    {children}
    {count > 0 && (
      <span className={styles.badge} aria-hidden="true">
        {getBadgeLabel(count)}
      </span>
    )}
  </span>
);

export default NotificationBadge;
